import { Component, Input } from "@angular/core";
import { ThirdPartyModel } from '@models/thirdparty/ThirdpartyModel';
import { LinkModel } from '@models/generic/LinkModel';
import { TabMenuItem } from '@models/generic/TabModels/TabMenuItem';
import { DatamanagementLinkableComponent } from '@app/datamanagement/pages/datamanagement-linkable/datamanagement-linkable.component';

@Component({
    selector: 'thirdparty-processingpurposes',
    templateUrl: './thirdparty-processingpurpose.component.html',
    styleUrls: ['./thirdparty-processingpurpose.component.scss'],
    imports: [DatamanagementLinkableComponent]
})

export class ThirdPartyProcessingPurposeComponent {
    @Input() model: ThirdPartyModel;

    linked: LinkModel[];
    unlinked: LinkModel[];
    isLoading = true;

    menuItem: TabMenuItem;
    tabIconBackup: string;

    load() {
        if (!this.model) {
            return;
        }
        this.isLoading = false;
    }

    getLinked(): number[] {
        return this.model.LinkedPp;
    }

    private loadData(linkedIds: number[], items: LinkModel[]) {
        const linked = [], unlinked = [];
        for (const item of items) {
            if (linkedIds.indexOf(item.id) >= 0 ) {
                linked.push(item);
            } else {
                unlinked.push(item);
            }
        }

        this.linked = linked;
        this.unlinked = unlinked;
    }

    linkedItemsChanged(linked: LinkModel[]) {
        
    }
}